export enum ROLE_ENUM {
  ADMINISTRATOR = "administrator",
  EDITOR = "editor",
  READER = "reader",
}
